import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
	getUserAccessToken,
	processAuthServerResponse
} from '@sorted/pkce-oauth';
import UserContext from '../../../context/UserContext';
import SplashPage from '../../components/SplashPage';
import settings from '../../settings';
import buildUserDetails from '../buildUserDetails';

const LoginCallback = () => {
	const userContext = useContext(UserContext);
	const [error, setError] = useState(false);
	const history = useHistory();

	useEffect(() => {
		setTimeout(() => {
			const response = new URLSearchParams(window.location.search);
			processAuthServerResponse(settings, '/auth/login/cb')
				.then(() => {
					return buildUserDetails(settings)
						.then(user => {
							userContext.setUser({
								...user,
								token: getUserAccessToken()
							});
							// we use state to retain the URL the user was on before auth
							history.push(response.get('state') || '/');
						})
						.catch(() => {
							userContext.setUser(null);
						});
				})
				.then(a => {
					return a;
				})
				.catch(e => {
					// This could be an error response from the OAuth server, or an error because the
					// request failed such as if the OAuth server doesn't allow CORS requests
					setError(e.error_description);
				});
		}, 2000);
	}, []);

	if (error) {
		return <SplashPage>{error}</SplashPage>;
	}

	return <SplashPage>Getting user details</SplashPage>;
};

export default LoginCallback;
